module.exports = __webpack_public_path__ + "img/icon_service.9ed16dd.svg";